import i18n from 'helper/i18n';
import { filterForTag } from './utils';

import { ContentTypePoolRecipeDtoType } from 'types/services/magnolia/dtos/ContentTypePoolRecipeDto';
import { AllergyType } from '../../../../../types/DietaryHabits';

// TODO: Refactor to ENUM
export const FILTER_ID = 'RECIPE_ALLERGY' as const;

export const RECIPE_TAG_IDS = {
	ALLERGY_GLUTEN: 'root.gluten.',
	ALLERGY_LACTOSE: 'root.lactose.',
} as const;

export const TAG_ID = 'allergy';

type FilterFactoryFunction = (item: ContentTypePoolRecipeDtoType) => boolean;

export const FILTER_FACTORY: { [key in AllergyType]: FilterFactoryFunction } = {
	LACTOSE: (item: ContentTypePoolRecipeDtoType) => filterForTag(item, TAG_ID, RECIPE_TAG_IDS.ALLERGY_LACTOSE),
	GLUTEN: (item: ContentTypePoolRecipeDtoType) => filterForTag(item, TAG_ID, RECIPE_TAG_IDS.ALLERGY_GLUTEN),
	UNKNOWN: (item: ContentTypePoolRecipeDtoType) => {
		return true;
	},
	NONE: (item: ContentTypePoolRecipeDtoType) => {
		return true;
	},
};

export const FILTER = {
	LACTOSE: 'LACTOSE',
	GLUTEN: 'GLUTEN',
} as const;

export const FILTER_LABELS: { [key: string]: any } = {
	LACTOSE: i18n(`react.impulsCoach.components.tagFilter.recipe.${FILTER_ID}.${FILTER.LACTOSE}`),
	GLUTEN: i18n(`react.impulsCoach.components.tagFilter.recipe.${FILTER_ID}.${FILTER.GLUTEN}`),
};

export function filterForAllergies(filter: (keyof typeof FILTER)[]): (item: ContentTypePoolRecipeDtoType) => boolean {
	return (item: ContentTypePoolRecipeDtoType) => {
		return filter.every((currentFilter) => {
			return FILTER_FACTORY[currentFilter](item);
		});
	};
}

export default filterForAllergies;
